export default "__VITE_ASSET__65c90049__"